import { render, staticRenderFns } from "./subjects-of-allegation-disability.vue?vue&type=template&id=38fe522c&scoped=true"
import script from "./subjects-of-allegation-disability.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation-disability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe522c",
  null
  
)

export default component.exports